import { theme } from 'antd';
import type { MediaLink } from '@entities/media';
import type { MessageStatus, MessageView } from '@entities/chat';

interface MessageBubbleProps {
  message: MessageView;
  own: boolean;
}

const STATUS_GLYPH: Record<MessageStatus, string> = {
  SENT: '✓',
  DELIVERED: '✓✓',
  READ: '✓✓',
};

export function MessageBubble({ message, own }: MessageBubbleProps) {
  const { token } = theme.useToken();
  return (
    <div style={{ display: 'flex', justifyContent: own ? 'flex-end' : 'flex-start' }}>
      <div
        style={{
          maxWidth: '78%',
          borderRadius: 14,
          padding: '8px 12px',
          background: own ? token.colorPrimary : token.colorFillSecondary,
          color: own ? '#fff' : token.colorText,
          boxShadow: '0 1px 1px rgba(0,0,0,0.04)',
          fontSize: 13,
          lineHeight: 1.45,
        }}
      >
        {message.body ? (
          <p style={{ margin: 0, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
            {message.body}
          </p>
        ) : null}
        {message.attachments.length > 0 ? (
          <ul style={{ margin: '8px 0 0', padding: 0, listStyle: 'none', display: 'flex', flexDirection: 'column', gap: 4 }}>
            {message.attachments.map((link) => (
              <Attachment key={link.id} link={link} own={own} />
            ))}
          </ul>
        ) : null}
        <div
          style={{
            marginTop: 4,
            display: 'flex',
            justifyContent: own ? 'flex-end' : 'flex-start',
            alignItems: 'center',
            gap: 4,
            fontSize: 10,
            opacity: 0.8,
          }}
        >
          <span>
            {new Date(message.createdAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
          </span>
          {own ? (
            <span style={{ color: message.status === 'READ' ? '#7dd3fc' : 'inherit' }}>
              {STATUS_GLYPH[message.status]}
            </span>
          ) : null}
        </div>
      </div>
    </div>
  );
}

function Attachment({ link, own }: { link: MediaLink; own: boolean }) {
  if (!link.url) {
    return (
      <li style={{ fontSize: 11, opacity: 0.7, fontFamily: 'ui-monospace, monospace' }}>
        {link.id.slice(0, 12)}…
      </li>
    );
  }
  return (
    <li>
      <a
        href={link.url}
        target="_blank"
        rel="noreferrer"
        style={{
          color: own ? '#fff' : 'inherit',
          fontSize: 11,
          textDecoration: 'underline',
        }}
      >
        Attachment ({link.id.slice(0, 8)}…)
      </a>
    </li>
  );
}
